import { useState, useCallback } from 'react';

type CallbackFunction = (
  value?: boolean | React.MouseEvent<HTMLElement>
) => void;

export function useToggle(
  initValue: boolean = false
): [boolean, CallbackFunction] {
  const [value, setToggleValue] = useState(initValue);

  const toggle = useCallback((forcedValue) => {
    if (typeof forcedValue === 'boolean') {
      setToggleValue(forcedValue);
      return;
    }
    setToggleValue((prevState) => !prevState);
  }, []);

  return [value, toggle];
}
